import { DayPicker } from 'react-day-picker'
import { Icon, buttonVariants } from '#app/ui/components'
import { cn } from '#app/utils/tailwind-merge.ts'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
	className,
	classNames,
	showOutsideDays = true,
	...props
}: CalendarProps) {
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			className={cn(`p-3`, className)}
			classNames={{
				months: `flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0`,
				month: `space-y-4`,
				caption: `flex justify-center pt-1 relative items-center`,
				caption_label: `text-brand-grey-light-1 text-sm font-medium`,
				nav: `space-x-1 flex items-center`,
				nav_button: cn(
					buttonVariants({ variant: `outline` }),
					`h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100`,
				),
				nav_button_previous: `absolute left-1`,
				nav_button_next: `absolute right-1`,
				table: `w-full border-collapse space-y-1`,
				head_row: `flex`,
				head_cell:
					`text-brand-grey-light-1 rounded-md w-9 font-normal text-[0.8rem]`,
				row: `flex w-full mt-2`,
				cell: `h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-muted-100 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20`,
				day: cn(
					buttonVariants({ variant: `ghost` }),
					`h-9 w-9 p-0 font-normal aria-selected:opacity-100`,
				),
				day_range_end: `day-range-end`,
				day_selected:
					`bg-brand-deep-pink text-brand-white hover:bg-brand-dark-pink hover:text-brand-white`,
				day_today: `border border-brand-gray-light-1 font-semibold`,
				day_outside:
					`text-muted-500 aria-selected:bg-muted-300 aria-selected:text-muted-100`,
				day_disabled: `text-muted-400`,
				day_range_middle:
					`aria-selected:text-muted-400`,
				day_hidden: `invisible`,
				...classNames,
			}}
			components={{
				IconLeft: () => <Icon name="chevron-left" className="h-4 w-4" />,
				IconRight: () => <Icon name="chevron-right" className="h-4 w-4" />,
			}}
			{...props}
		/>
	)
}
Calendar.displayName = `Calendar`

export { Calendar }
